import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ClientTypeInsertService {
	private apiUrl = globalConst.baseAPI;
	constructor(private http: Http) { }

	insertClientType(token, clienttype: any) {
		return this.http
			.post(this.apiUrl + "clienttypes/v1/insertclienttype", clienttype, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/client-type/service/client-type-insert/client-type-insert.service.ts